module.exports = __webpack_public_path__ + "static/media/gallery-8.954587b3.JPG";